import { render, staticRenderFns } from "./kabupaten.vue?vue&type=template&id=55eb8924&"
import script from "./kabupaten.vue?vue&type=script&lang=js&"
export * from "./kabupaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QCard,QCardSection,QInput,QBtn,QMarkupTable,QPagination,QDialog,QSelect,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QCard,QCardSection,QInput,QBtn,QMarkupTable,QPagination,QDialog,QSelect,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
